export default "__VITE_ASSET__df943240__"